import { SchedulerLead } from "managed-analytics/domain/SchedulerLead";

export type RawSchedulerLead = {
    uuid?: string;
    email: string;
    name: string;
    company: string;
    phone: string;
    schedule?: string;
    user?: string;
};


export const mapSchedulerLeadToApi = (schedulerLead: SchedulerLead): RawSchedulerLead => {

    return {
        uuid: schedulerLead.uuid,
        email: schedulerLead.email,
        name: schedulerLead.name,
        company: schedulerLead.company,
        phone: schedulerLead.phone,
        schedule: schedulerLead.schedule,
        user: schedulerLead.user,
    };
}